import React from "react"
import { FaCode, FaPencilRuler, FaServer } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "Front-end development",
    text: `I like to code things from scratch, and enjoy building Responsive websites which is optimal for user experience`,
    tools: ["Github", "VS Code", "JavaScript", "Html", "Scss"],
  },
  {
    id: 2,
    icon: <FaServer className="service-icon" />,
    title: "Back-end ",
    text: `I enjoy to build Rest Api End point from scratch and accessing from postman and Front-end `,
    tools: ["Node.js", "MongoDB", "Express", "Postman"],
  },
  {
    id: 3,
    icon: <FaPencilRuler className="service-icon" />,
    title: "design",
    text: `I value simple content structure, clean design patterns, and thoughtful interactions`,
    tools: ["Figma", "Pen & Paper"],
  },
]
